(function initPetPortraitBraceletRenderer() {
    const imageUrlPrefix = 'https://res.cloudinary.com/da9yd4bgx/image/fetch/t_pet_portrait_bracelet/';

    function renderPetPortraitBraceletOffer({ dogId } = {}) {
        const mediaGallery = document.querySelector('.main-product__media-gallery');
        const titleElement = document.querySelector('.main-product__blocks h1');
        const imageElement =
            document.querySelector('.rte.caption img') ||
            document.querySelector('.main-product__media-gallery img') ||
            document.createElement('img');

        if (!mediaGallery) {
            return;
        }

        mediaGallery.style.textAlign = 'center';
        mediaGallery.innerHTML = '<div class="loader"></div>';

        const renderSubmission = (submission) => {
            const submissionData = (submission && submission.data) || {};
            const submissionImageUrl = submissionData.image_url;
            const petName = submissionData.pet_name;

            if (petName && titleElement) {
                titleElement.innerHTML = `Personalized Pet Portrait Bracelet<br> ft. ${petName}`;
            }

            const petPortraitBraceletImageUrl = `${imageUrlPrefix}${encodeURIComponent(submissionImageUrl)}`;
            imageElement.src = petPortraitBraceletImageUrl;
            imageElement.setAttribute('srcset', petPortraitBraceletImageUrl);

            mediaGallery.innerHTML = '';
            mediaGallery.append(imageElement);
        };

        return loadSubmissionWithCache({ dogId, onLoaded: renderSubmission });
    }

    window.renderPetPortraitBraceletOffer = renderPetPortraitBraceletOffer;
})();
